import React, { useEffect, useState } from "react";
import { ProductCategory } from "~/common/Store/models/ProductPage";
import { ProductBrand } from "./ProductDetailPageResult";
interface Props {
  primaryBrand: ProductBrand;
  defaultCategory: ProductCategory;
}
const ProductDetailBrandSideSection = ({
  primaryBrand,
  defaultCategory
}: Props) => {
  const [brandImageLink, setBrandImageLink] = useState<string>("");
  useEffect(() => {
    const imageLinkArr = primaryBrand.imageLink.split(".");
    const imageFormat = imageLinkArr[1];
    if (imageFormat === "svg") {
      setBrandImageLink(`/images/vendor/${primaryBrand.imageLink}`);
    } else {
      setBrandImageLink(`/images/vendor/medium/${primaryBrand.imageLink}`);
    }
  }, [primaryBrand.imageLink]);
  const getBrandCategoryName = () => {
    const brandCategoryName = primaryBrand.name ? primaryBrand.name : "";
    if (primaryBrand?.brandedPrimaryCategoryName) {
      return primaryBrand.brandedPrimaryCategoryName;
    }
    if (defaultCategory?.name) {
      return brandCategoryName.concat(" ", defaultCategory.name);
    }
    return brandCategoryName;
  };
  return <div className="box padded" data-testid="brand-side-section" data-sentry-component="ProductDetailBrandSideSection" data-sentry-source-file="ProductDetailBrandSideSection.tsx">
      <div className="side-section">
        <a href={primaryBrand.link} title={primaryBrand.name} className="vendor-logo">
          <img className="lazyLoad b-loaded" src={brandImageLink} alt={`View All Products From ${primaryBrand.name}`} title={`View All Products From ${primaryBrand.name}`} style={{
          border: 0
        }} data-testid="brand-link" />
        </a>
        {defaultCategory && <a href={primaryBrand.categoryLinkWithVendor} title={primaryBrand.name} className="vendor-text" data-testid="brand-category-link">
            {`View all ${getBrandCategoryName()}`}
          </a>}
      </div>
    </div>;
};
export default ProductDetailBrandSideSection;